






















import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  Alert, NoticeClass, AuthStore,
} from '@kasasa/fbase-components/lib';
import {
  Cycle, CycleResource,
} from '@/api/cycles';

@Component({
  computed: mapState([
    'fiId',
  ]),
})
export default class CycleSelect extends Vue {
  @Prop({ default: false }) selectCurrent!: boolean;

  @Prop({ default: false }) selectPrevious!: boolean;

  @Prop({ default: false }) showQualEndDate!: false;

  @Prop({ default: false }) activeCyclesOnly!: false;

  @Prop({ default: false }) includeMonthEndDates!: false;

  @Prop({ default: null }) prefix!: string | null;

  loading: boolean = true;

  cycles: Cycle[] = [];

  fiId!: string;

  selectedCycle: Cycle | null = null;

  @Inject('CycleResource')
  cycleResource!: CycleResource;

  mounted() {
    this.loadData();
  }

  @Watch('fiId')
  loadData() {
    this.selectedCycle = null;
    this.loading = true;
    this.cycles = [];
    if (this.activeCyclesOnly) {
      this.loadActiveCycles();
    } else if (this.includeMonthEndDates) {
      this.loadAllCyclesWithMonthEndDate();
    } else {
      this.loadAllCycles();
    }
  }

  @Watch('selectCurrent')
  onSelectCurrentCycleChange() {
    if (this.selectCurrent) {
      this.selectCurrentCycle();
    }
  }

  @Watch('selectPrevious')
  onSelectPreviousCycleChange() {
    if (this.selectPreviousCycle) {
      this.selectPreviousCycle();
    }
  }

  selectCurrentCycle() {
    if (this.cycles && this.cycles.length > 0) {
      this.selectedCycle = this.cycles[0];
      this.onNewSelection();
    }
  }

  selectPreviousCycle() {
    if (this.cycles && this.cycles.length > 1) {
      this.selectedCycle = this.cycles[1];
      this.onNewSelection();
    }
  }

  async loadActiveCycles() {
    this.cycleResource.getActiveCycles(this.fiId).then((returnedCycles: Cycle[]) => {
      this.cycles = returnedCycles;
      if (this.cycles && this.cycles.length > 0 && this.selectCurrent) {
        this.selectedCycle = this.cycles[0];
        this.onNewSelection();
      }
    }).catch((error: any) => {
      this.showErrorMessage(error);
    }).finally(() => {
      this.loading = false;
    });
  }

  async loadAllCycles() {
    this.cycleResource.getAllCycles(this.fiId).then((returnedCycles: Cycle[]) => {
      this.cycles = returnedCycles;
      if (this.cycles && this.cycles.length > 0 && this.selectCurrent) {
        this.selectedCycle = this.cycles[0];
        this.onNewSelection();
      }
    }).catch((error: any) => {
      this.showErrorMessage(error);
    }).finally(() => {
      this.loading = false;
    });
  }

  async loadAllCyclesWithMonthEndDate() {
    this.cycleResource.getAllCyclesWithMonthEndDate(this.fiId).then((returnedCycles: Cycle[]) => {
      this.cycles = returnedCycles;
      if (this.cycles && this.cycles.length > 0 && this.selectCurrent) {
        this.selectedCycle = this.cycles[0];
        this.onNewSelection();
      }
    }).catch((error: any) => {
      this.showErrorMessage(error);
    }).finally(() => {
      this.loading = false;
    });
  }


  getCycleText(cycle: Cycle): string {
    let text: string = '';

    if (this.includeMonthEndDates && cycle.endOfMonthDateInCycle) {
      text = `Monthly Active Accounts: ${
        new Date(cycle.endOfMonthDateInCycle).toLocaleDateString('en-US', { timeZone: 'UTC' })}`;
      return text;
    }

    if (this.prefix !== null) {
      text = this.prefix;
    } else if (this.showQualEndDate) {
      text = 'Qual End Date: ';
    } else {
      text = 'Drop Date: ';
    }

    if (this.showQualEndDate) {
      text += new Date(cycle.qualificationEndDate).toLocaleDateString('en-US', { timeZone: 'UTC' });
    } else {
      text += new Date(cycle.dropDate).toLocaleDateString('en-US', { timeZone: 'UTC' });
    }
    return text;
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  onNewSelection() {
    this.$emit('input', this.selectedCycle);
  }
}
